
    // Only load Umami if not in development environment
    const environment = import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE;
    if (environment !== 'development') {
      const umamiScript = document.createElement('script');
      umamiScript.src = 'https://cloud.umami.is/script.js';
      umamiScript.setAttribute('data-website-id', 'f0618fc1-764e-4d5f-b182-ef2f82a31c53');
      umamiScript.defer = true;
      document.head.appendChild(umamiScript);
    }
  